import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function HelpBodyNutshellEmailMarketing() {
    return (
        <OnboardingBody title='What is email automation?'>
            <div>
                <p>
                    Send <b>personal email sequences</b> to your leads as they move through your
                    sales process. Emails are sent directly from lead assignees, so they’re more
                    likely to reach your prospect’s inbox.
                </p>
            </div>
        </OnboardingBody>
    );
}
